module.exports = "/assets/data/a9c3dc857269fcf8aead79d5f3a0c69a-KW17.data.json";